module.exports = __webpack_public_path__ + "img/DNARepair-CRC_10X_TGSP.325ad43b.png";